import React, { useState, useEffect } from "react";
import {Link} from "react-router-dom";
import LandingPageAppBar from "../../components/LandingPageAppBar";
import Footer from "../../components/common/Footer";
import MobileFooter from "../../components/common/MobileFooter";
import LoginForm from "../../components/common/LoginForm";

import logo from "../../assets/images/shecancode/logo.png";
const Login = () => {


  return (
    <>
      {/* <LandingPageAppBar /> */}
      <div style={{width:"100%",padding:"5% 30% 10% 30%",textAlign:"center"}}>
      <Link to="/land">
        <img src={logo} width="60%"></img>
        </Link>
        <br/>
        <LoginForm/></div>
      
      <Footer />
      <MobileFooter/>
   </>
  );
};


export default Login;
